module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2EpI7"))).then(() => parcelRequire('1iHdE'));